export default __webpack_public_path__ + "static/media/backTime.5ce47637.png";